import { Component, OnDestroy, OnInit } from '@angular/core';
import { NavigationEnd, NavigationStart, Router, RouterEvent, RoutesRecognized } from '@angular/router';
import { AcumaticaService } from 'src/app/acumatica/acumatica.service';
import { KitAuditService } from 'src/app/acumatica/EntityServices/KitAudit.service';
import { KitAuditType } from '../kit-audit';
import { ApplicationScreen } from 'src/app/application-navigator/application-screen';
import { filter, pairwise } from 'rxjs/operators';
import { Subscription } from 'rxjs';
import { UrlService } from 'src/app/services/url.service';
import { MatDialog } from '@angular/material/dialog';
import { AlertDialog } from 'src/app/common/alert-dialog/alert-dialog.component';

@Component({
  selector: 'app-audit-type',
  templateUrl: './audit-type.component.html',
  styleUrls: ['./audit-type.component.css']
})
export class KitAuditTypeSelectionComponent extends ApplicationScreen implements OnInit, OnDestroy {

  public isCheckingLoggedIn = true;
  public pageTitle = "Mayer Fabrics Kit Audit";
  private browserNavigationSubscription?: Subscription;
  
  constructor(
    private router: Router,
    private urlService: UrlService,
    private dialog: MatDialog,
    
    private acumatica: AcumaticaService,
    private kitAudit: KitAuditService
  ) {
    super();
  }

  private handleBrowserNavigation(previousUrl: string) {
    // if nothing has been checked in the audit, clear any in-progress audit-operation
    if(!this.kitAudit?.audit?.AnyChecked()) this.kitAudit.audit = undefined;

    // when no kit audit in progress, do not auto re-navigate
    if(this.kitAudit.audit == undefined) return;

    // when there is a kit audit in progress and user comes to the screen, skip past it
    if(previousUrl == '/kit-audit/select')
      // user is navigating Back from kit-selection screen so go to main menu
      this.router.navigate(['/']);
    else if(previousUrl == '/' || previousUrl == '')
      // user is navigating here from main menu so go to kit selection
      this.router.navigate(['kit-audit', 'select']);      
  }

  public ngOnInit(): void {
    // ensure a valid login session at start of this screen
    // prevent multiple login prompts in case of multiple concurrent async requests
    this.acumatica.CheckLogInStatus().subscribe(() => {
      this.isCheckingLoggedIn = false;
    });

    this.browserNavigationSubscription = this.urlService.previousUrl.subscribe(url => this.handleBrowserNavigation(url));
  }

  public ngOnDestroy(): void {
    this.browserNavigationSubscription?.unsubscribe();
  }

  public cancel() { this.router.navigate(['/']); }

  public doBinderAudit() {
    this.kitAudit.StartNewAudit(KitAuditType.Binders)
    .then(() => this.gotoSelectKit())
    .catch(err => this.ShowErrorDialog(err));
  }

  public doLoseCardAudit() {
    this.kitAudit.StartNewAudit(KitAuditType.LooseCards)
    .then(() => this.gotoSelectKit())
    .catch(err => this.ShowErrorDialog(err));
  }

  public doCollatedSetAudit() {
    this.kitAudit.StartNewAudit(KitAuditType.CollatedSets).then(() => this.gotoSelectKit());
  }

  private gotoSelectKit() { this.router.navigate(['kit-audit', 'select']); }

  private ShowErrorDialog(errMessage: string) {
    this.dialog.open(AlertDialog, {data: {message:errMessage, icon:'warning'}});
  }
}
